import Joi from 'joi-browser';

import { DISPLAY_FLAG } from '../../../utilities/constants';
import { customValidateDate } from '../../../utilities/validateDateUtil';
import { isNullOrUndefinedOrEmptyStr } from '../../../utilities/stringUtil';

/**
 * コンボボックスのデータを取得用のリクエストパラメタを作成する
 * @return {object} 取得用パラメータ
 * */
const createFetchComboBoxListParam = () => {
  return { display_flag: DISPLAY_FLAG.use.id };
};

/**
 * コンボボックスのデータを取得用のリクエストパラメタを作成する
 * @param {object} param:登録パラメーター
 * @return {object} 取得用パラメータ
 * */
const createFetchLicentiateValidPeriodsParam = param => {
  const searchParam = Object.create(null);
  if (!isNullOrUndefinedOrEmptyStr(param.licentiate_cd)) {
    searchParam.large_class_cd = param.licentiate_cd;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.ccusMLicentiatesLargeClasses)) {
    searchParam.large_class_cd = param.ccusMLicentiatesLargeClasses.CODE;
  }
  return searchParam;
};

/**
 * バリデーション用のスキーマを作成する
 * @return {object}validateSchema:バリデーション用のスキーマ
 * */
const createValidateSchema = () => {
  return {
    worker_trainings: Joi.array().items(
      Joi.object({
        training_name: Joi.string()
          .max(255)
          .allow(null, ''),
        training_take_date: customValidateDate.base().validateDate(),
      })
    ),
    worker_special_trainings: Joi.array().items(
      Joi.object({
        specal_training_name: Joi.string()
          .max(255)
          .allow(null, ''),
        specal_training_take_date: customValidateDate.base().validateDate(),
      })
    ),
    worker_safety_trainings: Joi.array().items(
      Joi.object({
        safety_training_name: Joi.string()
          .max(255)
          .allow(null, ''),
        safety_training_take_date: customValidateDate.base().validateDate(),
        safety_training_expire_date: customValidateDate.base().validateDate(),
      })
    ),
    worker_commendations: Joi.array().items(
      Joi.object({
        commendation_name: Joi.string()
          .max(255)
          .allow(null, ''),
        commendation_date: customValidateDate.base().validateDate(),
      })
    ),
  };
};

const createSafetyDocItemSchema = () => {
  const schema = {
    worker_trainings: Joi.array().items(
      Joi.object().keys({
        training_name: Joi.string().required(),
      })
    ),
    worker_special_trainings: Joi.array().items(
      Joi.object().keys({
        specal_training_name: Joi.string().required(),
      })
    ),
    worker_safety_trainings: Joi.array().items(
      Joi.object().keys({
        safety_training_name: Joi.string().required(),
      })
    ),
  };
  return schema;
};

/**
 *
 * */
const TrainingCommendationService = {
  createFetchComboBoxListParam,
  createFetchLicentiateValidPeriodsParam,
  createValidateSchema,
  createSafetyDocItemSchema,
};

export default TrainingCommendationService;



// WEBPACK FOOTER //
// ./src/services/workers/trainingCommendation/TrainingCommendationService.js